import script from "./CusSelectForDiagnostic.vue?vue&type=script&setup=true&lang=js"
export * from "./CusSelectForDiagnostic.vue?vue&type=script&setup=true&lang=js"

import "./CusSelectForDiagnostic.vue?vue&type=style&index=0&id=1c1b2b8a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c1b2b8a"]])

export default __exports__